"use client";

import { Card, Table, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { fetchAppUsageTable } from "../../../../api/api";

const Courses = ({ user_id }) => {
  const [apps, setApps] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 4;

  const formatDuration = (seconds) => {
    const sec = Number(seconds) || 0;
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    return `${h}h ${m}m`;
  };

  useEffect(() => {
    if (!user_id) return;

    const loadApps = async () => {
      try {
        const data = await fetchAppUsageTable(user_id);
        setApps(data || []);
      } catch (err) {
        console.error("Failed to fetch app usage:", err);
      }
    };

    loadApps();
  }, [user_id]);

  // ✅ Pagination logic
  const totalPages = Math.ceil(apps.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentApps = apps.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body>
        <h3 className="mb-3">App Usage</h3>

        <div className="table-responsive">
          <Table className="align-middle table-bordered">
            <thead className="table-light">
              <tr>
                <th>App Name</th>
                <th>Window Title</th>
                <th>Date</th>
                <th>Duration</th>
              </tr>
            </thead>

            <tbody>
              {currentApps.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    No app usage found
                  </td>
                </tr>
              ) : (
                currentApps.map((app) => (
                  <tr key={app.id}>
                    <td>{app.app_name}</td>
                    <td>{app.window_title}</td>
                    <td>{new Date(app.usage_date).toLocaleDateString()}</td>
                    <td>{formatDuration(app.total_duration_seconds)}</td>
                   
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>

        {/* ✅ Pagination UI */}
        {apps.length > 5 && (
          <div className="d-flex justify-content-between align-items-center mt-3">
            <span>
              Showing {startIndex + 1} to{" "}
              {Math.min(startIndex + itemsPerPage, apps.length)} of{" "}
              {apps.length}
            </span>

            <div>
              <Button
                variant="light"
                className="me-2"
                onClick={handlePrev}
                disabled={currentPage === 1}
              >
                Prev
              </Button>

              <Button
                variant="light"
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                Next
              </Button>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default Courses;